import {
  IonCol,
  IonContent,
  IonGrid,
  IonPage,
  IonRow,
  IonText,
} from "@ionic/react";
import { makePATCHRequest } from "../../request/rawRequest";
import { Techno } from "../../types/techno";
import "../IonColor/color.css";
import LogoLogin from "../Login/LogoLogin";
import TitlePage from "../TitlePage/TitlePage";
import "../generalCSS/stylesheet.css";
import "./TechnoList.css";

interface ContainerProps {
  pathLogo: string;
}

export const technosActive: Techno[] = [
  {
    name: "Pâtisserie",
    url: "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/Images/Pa%CC%82tisserie-+Formace%CC%81o.png",
    active: true,
    href: "pat",
  },
  {
    name: "Boulangerie",
    url: "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/Images/Boulangerie-+Formace%CC%81o.png",
    active: true,
    href: "boul",
  },
  {
    name: "Charcuterie",
    url: "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/Images/Lapin+saut%C3%A9+chasseur.00_04_15_11.Still002.jpg",
    active: true,
    href: "char",
  },
  {
    name: "Primeur",
    url: "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/Images/Corbeille+-mains-UNE.jpg",
    active: true,
    href: "prim",
  },
  {
    name: "Cuisine",
    url: "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/Images/PAT-tuto.jpg",
    active: true,
    href: "cuis",
  },
  {
    name: "Premium",
    url: "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/Images/Boulangerie-+Formace%CC%81o.png",
    active: true,
    href: "pat",
    option: "premium=true",
  },
];

const Register: React.FC<ContainerProps> = ({ pathLogo }) => {
  const technosDisable: Techno[] = [
    {
      name: "Chocolat",
      url: "https://randomwordgenerator.com/img/picture-generator/57e5d1464f53a414f1dc8460962e33791c3ad6e04e5074417c2f7cd3924fc7_640.jpg",
      active: false,
      href: "",
    },
  ];

  return (
    <IonPage className="register">
      <IonContent color="primary">
        <IonGrid>
          <LogoLogin path={pathLogo} />
          <IonRow className="ion-justify-content-center">
            <IonCol id="technoList" size-lg="5" size-sm="10">
              <TitlePage
                title="Bienvenue"
                subTitle="Quel module voulez-vous étudiez ?"
              />
              {displayTechnoActive(technosActive)}
              {displaySeparator()}
              {displayTechnoDisabled(technosDisable)}
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};

export const displayTechnoActive = (
  arr: Techno[],
  size?: "12",
  req?: boolean,
) => {
  return arr.map(function (techno, i) {
    return (
      <IonRow className="ion-justify-content-center" key={i}>
        <IonCol
          size-sm={size ?? "12"}
          size-lg={size ?? "7"}
          className={"techno-item techno-active " + (i === 1 ? "last " : "")}
          style={{ backgroundImage: "url(" + techno.url + ")" }}
          onClick={async function () {
            localStorage.setItem("techno", techno.href);
            if (req !== undefined && req === true) {
              await makePATCHRequest("/pole?pole=" + techno.href)
                .then((response) => {
                  window.location.reload();
                })
                .catch((error) => {
                  localStorage.removeItem("authToken");
                });
            } else {
              window.location.href =
                "techno/register" + (techno.option ? "?" + techno.option : "");
            }
          }}
        >
          <IonRow className="ion-justify-content-start vertical-align">
            <IonText color="white">
              <h4 className="techno-name uppercase">{techno.name}</h4>
            </IonText>
          </IonRow>
        </IonCol>
      </IonRow>
    );
  });
};

const displayTechnoDisabled = (arr: Techno[]) => {
  return arr.map(function (techno, i) {
    return (
      <IonRow className="ion-justify-content-center" key={i}>
        <IonCol
          size-sm="12"
          size-lg="7"
          className="techno-item techno-disable"
          style={{ backgroundImage: "url(" + techno.url + ")" }}
        >
          <IonRow className="ion-justify-content-start vertical-align">
            <IonText color="white">
              <h4 className="techno-name uppercase">{techno.name}</h4>
            </IonText>
          </IonRow>
        </IonCol>
      </IonRow>
    );
  });
};

const displaySeparator = () => {
  return (
    <IonRow className="ion-justify-content-center">
      <IonCol size-sm="12" size-lg="7">
        <IonText color="black" className="ion-text-start">
          <h5 className="bold">À venir ...</h5>
        </IonText>
      </IonCol>
    </IonRow>
  );
};

export default Register;
